export default __webpack_public_path__ + "static/media/ISSO CLASS-1_SYLLABUS_2025-26.e88f499a.pdf";